module.exports = __webpack_public_path__ + "static/media/iphone.e74dbc47.png";